import Papa from 'papaparse';

export const parseContactsCsv = (text) => {
  const parsed = Papa.parse(text, {
    header: true,
    skipEmptyLines: 'greedy',
    transformHeader: header => header.replace(/^\uFEFF/, '').trim().toLowerCase(),
  });
  if (parsed.errors.length) {
    throw new Error(`Invalid CSV at row ${parsed.errors[0].row + 2}: ${parsed.errors[0].message}`);
  }
  const fields = parsed.meta.fields || [];
  if (fields.length !== 4 || !['name', 'address', 'email', 'phone'].every(field => fields.includes(field))) {
    throw new Error('CSV headers must be Name, Address, Email, Phone');
  }
  if (!parsed.data.length || parsed.data.length > 500) {
    throw new Error('CSV must contain between 1 and 500 contacts');
  }
  return parsed.data.map(row => Object.fromEntries(
    fields.map(field => [field, row[field].replace(/^'(?=\s*[=+\-@])/, '')])
  ));
};
